// @flow
import { commitMutation, graphql } from 'react-relay';

// function getOptimisticResponse({ cart }) {
//   return {
//     cartTogglePCMembership: {
//       cart: {
//         ...cart,
//         enrollingAsPc: !cart.enrollingAsPc,
//       },
//     },
//   };
// }

export const mutation = graphql`
  mutation CartTogglePCMembershipMutation(
    $input: CartTogglePCMembershipMutationInput!
  ) {
    cartTogglePCMembership(input: $input) {
      cart {
        id
        autoShipEnabled
        autoShipIntervalUnit
        autoShipIntervalCount
        c4cMode
        enrollingAsPc
        totalSavings
        promoCodeSavings
        pcPotentialSavings
        viaQualifiedCartTotal
        totalNumberOfItems
        subTotalPriceOfItems
        subTotalPriceOfItemsWithPromoCodes
        promoCodeIsValid
        totalNumberOfItems
        eventId
        entries {
          edges {
            node {
              id
              product {
                id
                name
                price
                productURLslug
                images {
                  id
                  productCatalog
                }
                categoryFood
                categoryMerch
                categoryWine
                company
                priceSale
                productId
                inventorySKU
                productPermissions {
                  oneCommerce {
                    preferredCustomer {
                      add
                    }
                  }
                }
                promoCodeDiscount {
                  case4Cause {
                    case12PriceUSD
                    case6PriceUSD
                    case6SKU
                    case12SKU
                    donationEligible
                  }
                }
              }
              quantity
            }
          }
        }
        promoCodes {
          code
          promoDescription
          thresholds {
            discountAmount
            discountAmountEach
          }
        }
        promoCodeDiscountedItems {
          id
          nonDiscountedSkus {
            edges {
              node {
                id
                sku
                discountAmount
                productId
                quantity
                product {
                  id
                  productId
                  productURLslug
                  name
                  price
                  priceSale
                  productPermissions {
                    oneCommerce {
                      preferredCustomer {
                        add
                      }
                    }
                  }
                  promoCodeDiscount {
                    case4Cause {
                      case6PriceUSD
                    }
                  }
                  images {
                    id
                    productCatalog
                    productFront
                    productBack
                  }
                }
              }
            }
          }
          discountedSkus {
            edges {
              node {
                id
                sku
                discountAmount
                productId
                quantity
                product {
                  id
                  productId
                  productURLslug
                  name
                  price
                  priceSale
                  productPermissions {
                    oneCommerce {
                      preferredCustomer {
                        add
                      }
                    }
                  }
                  promoCodeDiscount {
                    case4Cause {
                      case6PriceUSD
                    }
                  }
                  images {
                    id
                    productCatalog
                    productFront
                    productBack
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

function commit({ environment, onCompleted, onError }) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {},
    },
    // optimisticResponse: getOptimisticResponse({ cart }),
    onCompleted,
    onError,
  });
}

export default { commit };
